import { Placeholder, Skeleton, Stack } from '@sixui/ui';

export const AppGridItemSkeleton: React.FC = () => (
  <Stack gap={4} align="center">
    <Skeleton>
      <Placeholder width={120} height={120} />
    </Skeleton>
    <Skeleton length={{ min: 4, max: 16 }} />
  </Stack>
);
